import { useSession } from 'next-auth/react';

export const useDefaultPath = () => {
  const { data: session } = useSession();
  const userRoles = session?.roles ?? [];
  const userHasReportsRole = userRoles.includes('reports');
  return userHasReportsRole ? '/dashboard' : '/clients';
};
